import React from 'react'
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer'
import Dropdown from '../../components/Dropdown/Dropdown';
import Nav from '../../components/Nav/Nav'
import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font';

//right carrots
//import u80 from '../../images/hsa-dashboard/u80.png'
//import u144 from '../../images/hsa-dashboard/u144.png'//mouseover

//Sort Direction Indicatiors (Triangles)
import u274 from '../../images/accounts/u274.png'
import u275 from '../../images/accounts/u275.png'


//data
import { transactions } from '../../testdata/transactions';


import TransactionCard from '../../components/TransactionCard/TransactionCard';
import PageNavigator from '../../components/PageNavigator/PageNavigator';


export default class AccountActivity extends React.Component{

    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.state={
            //modal vars
            view_height:null,
            show_modal:false,

            //transaction page handling
            pagerIndex:0,

            //Account Summary Box
            contr_year:2024,
            contr_year_list:[2021,2022,2023,2024],
            contr:625.00, //contributions
            ballance:3850.00,
            earnings:21.27,
            earnings_mode:'YTD',
            earning_mode_list:['YTD','This Month', 'Last Month'],
            available_spending:981.27,
            
            //Recent Activity Box
            transactions:[
                {title:'Hometown Pharmacy',date:'June 12', amount:-12.29},
                {title:'Interest',date:'June 01', amount:1.18},
                {title:'Reimbursement',date:'May 27', amount:-9.15},
                {title:'Best Family Practice',date:'May 25', amount:-15.00},
                {title:'DontDisplay Inc.',date:'May 12',amount:100}
            ],

            //card variables
            card1_active:true,
            card2_active:true
        }
    }
    
    componentDidMount=()=>{
        const parentHeight = this.parentRef.current.clientHeight;
        this.setState({ view_height:parentHeight });
        this.setState({maxIndex:Math.ceil(transactions.length/9)})
    }
    
    navLeft=()=>{
        const {pagerIndex}=this.state
        if(pagerIndex===0)
            return
        this.setState({pagerIndex:pagerIndex-1})
    }
    navRight=()=>{
        const pagerIndex=this.state.pagerIndex
        const maxIndex=this.state.maxIndex
        if(pagerIndex===maxIndex-1)
            return
        this.setState({pagerIndex:pagerIndex+1})
        //alert(this.state.pagerIndex)
    }

    renderTransactions=()=>{
        const transactionList = transactions;
        var minIndex=this.state.pagerIndex*9
        var maxIndex=minIndex+9<transactionList.length?minIndex+9:transactionList.length //renders next nine
        const reducedArray=transactionList.slice(minIndex,maxIndex)
        
        return(
            <div>
           { reducedArray.map((item, index)=><TransactionCard key={index} status={item.status} action={item.action} type={item.type} date={item.date} provider={item.provider} accNumber={item.account} service={item.service} amount={item.amount}/>)}
           </div>
        )
    }

    render(){
        return <div ref={this.parentRef} style={{display:'flex',height:"auto", width:'auto',flexDirection:'column', backgroundColor:Colors.light_grey,overflowX:'hidden'}}>
            <Header authed={true} navigator={this.props.navigator}/>
            <div style={{ display:'flex', flexDirection:'row', backgroundColor:Colors.light_grey}}>
                <div style={{ display:'flex',flex:1,justifyContent:'right',alignItems:'right'}}>
                    <Nav navigator={this.props.navigator} page='accountActivity'/>
                </div>
                <div style={{ display:'flex',flexDirection:'column',flex:3, paddingTop:'2.4vh', paddingLeft:"1vw",paddingRight:'20vw'}}>
                    <div>{/**Title*/}
                        <span style={{...Fonts.title,color:"#003F97"}}><span style={{...Fonts.title,color:'#000'}}>Accounts / </span>Account Activity</span>
                    </div>
                    <div style={{background:"#FFF",width:"47vw",height:'120vh', border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:'2.3vh'}}>{/**white view */}
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center', marginTop:'2.8vh', marginLeft:'1vw'}}>{/**white view header */}
                            <span style={{...Fonts.subtitle, marginRight:'0.7vw'}}>Year</span>
                            <Dropdown items={this.state.contr_year_list} defaultValue={this.state.contr_year} onChange={(val)=>{this.setState({contr_year:val})}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'row',marginTop:'3vh',marginBottom:'-1vh'}}> {/* Sort Filters */}
                            <div style={{display:'flex',flexDirection:'row', alignItems:'center', width:'7.8vw',marginLeft:'2vw'}}>
                                <span style={{...Fonts.faded_label}}>Status</span> {/* Sort filter label */}
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'space-evenly', padding:'0.7vh'}}> {/* Sort Direction Indicator */}
                                    <img style={{padding:"0.2vh"}} src={u274} alt='up'/>  <img style={{padding:"0.2vh"}} src={u275} alt='down'/>
                                </div>
                            </div>
                            <div style={{display:'flex',flexDirection:'row', alignItems:'center', width:'5vw'}}>
                                <span style={{...Fonts.faded_label}}>Action</span> {/* Sort filter label */}
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'space-evenly', padding:'0.7vh'}}> {/* Sort Direction Indicator */}
                                    <img style={{padding:"0.2vh"}} src={u274} alt='up'/>  <img style={{padding:"0.2vh"}} src={u275} alt='down'/>
                                </div>
                            </div>
                            <div style={{display:'flex',flexDirection:'row', alignItems:'center', width:'6.6vw'}}>
                                <span style={{...Fonts.faded_label}}>Type</span> {/* Sort filter label */}
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'space-evenly', padding:'0.7vh'}}> {/* Sort Direction Indicator */}
                                    <img style={{padding:"0.2vh"}} src={u274} alt='up'/>  <img style={{padding:"0.2vh"}} src={u275} alt='down'/>
                                </div>
                            </div>
                            <div style={{display:'flex',flexDirection:'row', alignItems:'center', width:'17.8vw'}}>
                                <span style={{...Fonts.faded_label}}>Transaction Date</span> {/* Sort filter label */}
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'space-evenly', padding:'0.7vh'}}> {/* Sort Direction Indicator */}
                                    <img style={{padding:"0.2vh"}} src={u274} alt='up'/>  <img style={{padding:"0.2vh"}} src={u275} alt='down'/>
                                </div>
                            </div>
                            <div style={{display:'flex',flexDirection:'row', alignItems:'center'}}>
                                <span style={{...Fonts.faded_label}}>Amount</span> {/* Sort filter label */}
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'space-evenly', padding:'0.7vh'}}> {/* Sort Direction Indicator */}
                                    <img style={{padding:"0.2vh"}} src={u274} alt='up'/>  <img style={{padding:"0.2vh"}} src={u275} alt='down'/>
                                </div>
                            </div>
                        </div>
                        <div style={{display:'flex',flexDirection:"column",height:'100vh',marginBottom:'-3.5vh'}}>{/* Transaction Container */}
                            {this.renderTransactions()}
                        </div>
                        <PageNavigator index={this.state.pagerIndex+1} length={this.state.maxIndex} navLeft={this.navLeft} navRight={this.navRight} />
                    </div>
                    <div style={{display:'flex',height:'9vh', background:Colors.light_grey,}}></div>
                </div>
                
            </div>
            
            <Footer/>
        </div>
    }
}